// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/weather-radar.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/weather-radar/weather-radar.js';

mount([g0]);
